export enum MasterProcedureProductSource {
    C3 = 'C3',
    Metals = 'Metals',
    Plastics = 'Plastics',
}

export interface MasterProcedureProductLink {
    source: MasterProcedureProductSource;
    productId: string;
}

export interface MasterProcedureStep {
    id: string;
    procedureId: string;
    nextStepId: string | null;
    products: MasterProcedureProductLink[];
    x: number;
    y: number;
}

export interface MasterProcedureProductSummary extends MasterProcedureProductLink {
    productVersionId: string;
    partNumber: string;
    description: string;
    thumbnailImageUrl: string;
}
